import axios from "axios";
import { QueryClient } from "@tanstack/react-query";

const BASE_URL = process.env.REACT_APP_HOST_URL;

if (!BASE_URL) {
  console.error(
    "REACT_APP_HOST_URL is not set. Please create a .env file with REACT_APP_HOST_URL, REACT_APP_AUTH_USERNAME, and REACT_APP_AUTH_PASSWORD"
  );
}

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const getAccessToken = async (): Promise<string> => {
  if (!BASE_URL) {
    throw new Error(
      "REACT_APP_HOST_URL is not set. Please create a .env file in the root directory with REACT_APP_HOST_URL, REACT_APP_AUTH_USERNAME, and REACT_APP_AUTH_PASSWORD"
    );
  }
  
  localStorage.removeItem("token");
  const response = await axios.post(
    `${BASE_URL}/oauth/token`,
    {},
    {
      auth: {
        username: process.env.REACT_APP_AUTH_USERNAME as string,
        password: process.env.REACT_APP_AUTH_PASSWORD as string,
      },
    }
  );

  return response.data.record.access_token;
};

apiClient.interceptors.request.use(async (config) => {
  const token = await getAccessToken();

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("token", token);
  }

  return config;
});

export const queryClient = new QueryClient();

export default apiClient;
